import { useEffect } from 'react';
import { trackPageView } from 'srcAlias/client/analytics';
import { useSelector } from 'react-redux';
import {
  selectApplicationId,
  selectProductDetails,
  selectSessionId,
} from 'srcAlias/client/state/selectors';
import { store } from 'srcAlias/initialization';
import { get, isEmpty } from 'lodash-es';

export const trackPageViewAnalytics = ({
  pageName,
  applicationId,
  accountType,
  sessionId,
  productSelection,
}) => {
  if (pageName === 'declaration' && isEmpty(productSelection)) {
    return;
  }
  trackPageView({
    pageName,
    keyPath: pageName,
    state: {
      application: {
        applicationId,
      },
      accountType,
      productSelection,
      sessionId,
    },
  });
};

export const useTrackPageViewAnalyticsHook = (pageName) => {
  const applicationId = useSelector(selectApplicationId);
  const sessionId = useSelector(selectSessionId);
  const productSelection = useSelector(selectProductDetails);

  useEffect(() => {
    trackPageViewAnalytics({
      pageName,
      applicationId,
      sessionId,
      productSelection,
    });
  }, [productSelection]);
};

export const useTrackPageViewAnalyticsFunction = (pageName) => {
  const reduxState = store.getState();
  const applicationId = get(
    reduxState,
    'eligibility.responseData.data.applicationId',
    ''
  );
  const sessionId = get(reduxState, 'sessionId', '');
  const productSelection = get(reduxState, 'productSelection', {});

  trackPageViewAnalytics({
    pageName,
    applicationId,
    sessionId,
    productSelection,
  });
};

export default useTrackPageViewAnalyticsHook;
